import { atob, btoa } from 'js-base64';
import Cookie from 'js-cookie';
import getConfig from 'next/config';

const isServer = typeof window === 'undefined';
const { publicRuntimeConfig } = getConfig();

const decodeToken = (token) => {
    const [, payload = ''] = token.split('.');
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));

    return JSON.parse(decodedPayload);
};

const Persistor = () => {
    let _cookies;

    return {
        setCookies: (cookies) => {
            _cookies = cookies;
        },
        setTokens: ({ refreshToken, token }) => {
            if (refreshToken) {
                const { exp } = decodeToken(refreshToken);
                Cookie.set('kcRefreshToken', btoa(refreshToken), { expires: new Date(exp * 1000) });
            }
            if (token) {
                const { exp } = decodeToken(token);
                Cookie.set('kcToken', btoa(token), { expires: new Date(exp * 1000) });
            }
        },
        setInitialLoginFlow: () => {
            Cookie.set('kcInitialLoginFlow', 1, { expires: 1 / 24 * 2 }); // in two hours
        },
        getTokens: () => {
            const refreshToken = isServer ? _cookies.kcRefreshToken : Cookie.get('kcRefreshToken');
            const token = isServer ? _cookies.kcToken : Cookie.get('kcToken');
            const initialLoginFlow = isServer ? _cookies.kcInitialLoginFlow : Cookie.get('kcInitialLoginFlow');

            return {
                refreshToken: refreshToken ? atob(refreshToken) : undefined,
                token: token ? atob(token) : undefined,
                initialLoginFlow,
            };
        },
        resetTokens: () => {
            Cookie.remove('kcRefreshToken');
            Cookie.remove('kcToken');
            Cookie.remove('kcInitialLoginFlow');
        },
        setAffiliateNetwork: ({ affiliate, value }) => {
            Cookie.set('affiliateNetwork', JSON.stringify({ name: affiliate.name, value }), {
                expires: publicRuntimeConfig.affiliateNetworks[affiliate.name].expiry,
            });
        },
        getAffiliateNetwork: () => {
            const affiliateNetwork = Cookie.get('affiliateNetwork');
            if (!affiliateNetwork) return;
            return JSON.parse(affiliateNetwork);
        },
    };
};

export default Persistor();
